import { Resource as ResourceType } from '@/generated/contentfulTypes';
import ClientResource from './ClientResource';
import { Suspense } from 'react';

export interface ResourceProps extends Pick<ResourceType, 'value'> {
  replaceValues?: Record<string, string>;
}

const hasHtml = (html: string): boolean => /<\/?[a-z][\s\S]*>/i.test(html);

export default function Resource({ value, replaceValues }: ResourceProps) {
  if (!value) return null;

  const containsHtml = hasHtml(value);
  const hasReplacements =
    replaceValues && Object.keys(replaceValues).length > 0;

  // Text-only, static rendering
  if (!containsHtml && !hasReplacements) {
    return <>{value}</>;
  }

  if (!containsHtml && hasReplacements) {
    let result = value;
    Object.entries(replaceValues!).forEach(([key, replacement]) => {
      const regex = new RegExp(`%${key}%`, 'g');
      result = result.replace(regex, replacement);
    });
    return <>{result}</>;
  }

  // Defer HTML rendering to client
  return (
    <Suspense>
      <ClientResource value={value} replaceValues={replaceValues} />
    </Suspense>
  );
}
